import {
  getListofResponsibility,
  getListofResponsibilityBadge,
  createProficiencyBadge,
  getListofEmployee,
  deleteResponsibilityBadge,
  responsibilityStateUpdate,
  updateActivateResponsibility,
  updateArchiveResponsibility,
  updateUnArchiveResponsibility,
  deleteResponsibility,
  getResponsibilityIdV2,
  getResponsibilityId,
  getListofEmployeeOfResId,
  getChatterList,
  getResponsibilityChecklist,
  createResponsibilityCheckpoint,
  createResponsibilityCheckpointV2,
  deleteResponsibilityCheckpoint,
  getRoleId,
  checkpointStateUpdate,
  changeCheckpoint,
  onUpdateCheckpointOrder,
  getListActiveCheckpointsEval,
  getListActiveCheckpointsEvalV2,
  getCheckpointChatterList,
  detachOrgObject,
  getResponsibilityAssignments,
  uploadMicrolearningCheckPoint,
  reOrderSequenceData,
  updateRetireResponsibility,
  updateReActivateResponsibility,
  updateImportanceValue,
  createResponsibilityDefaultBadge,
  getResponsibilityChecklistV2,
  createResponsibility,
  fetchAttachableResponsibilities,
  fetchAttachableRoles,
  fetchAttachableRolesForPosition,
  changeCheckpointV2,
  updateResponsibilityDefaults,
  updateResponsibilityContext,
} from "@/api";
import { getDeleteErrorMessage } from "@components/utils/getDeleteErrorMessage";
import { useSelfAppointPromptStore } from "@/store/pinia/selfAppointPrompt";
import { getResponsibilityCreateErrorMessage } from "@components/utils/responsibilityNameError";
import { formatCriteriaPrefix } from "@components/utils/formatCriteriaPrefix";
import AddResponsibility from "@components/RolesCatalog/AddResponsibilityDialog/AddResponsibilityDialog.vue";
import ExResponsibilityModal from "@components/ResponsibilityModal/ExResponsibilityModal.vue";
import EmployeeModal from "@components/EmployeeModal/EmployeeModal.vue";
import ConfirmationDialog from "@components/RolesCatalog/Confirmation.vue";
import RenameResponsibilityDialog from "@components/RolesCatalog/RenameResponsibilityDialog/RenameResponsibilityDialog.vue";
import { toRenameResponsibilityModel } from "@components/utils/renameResponsibilityModel";
import DeleteResponsibility from "@components/RolesCatalog/DeleteResponsibility.vue";
import ActivateResponsibility from "@components/RolesCatalog/ActivateResponsibility.vue";
import RetireResponsibility from "@components/RolesCatalog/RetireResponsibility.vue";
import DeActivateResponsibility from "@components/RolesCatalog/DeActivateResponsibility.vue";
import ReActivateResponsibility from "@components/RolesCatalog/ReActivateResponsibility.vue";
import DetachResponsibilityDialog from "@components/DetachRes/DetachResponsibilityDialog.vue";
import { useHighlightRow } from "@/composables/common/useHighlightRow";
import { useEmployeeViewState } from "../../../account/src/views/Employees/composables/useEmployeeViewState";

const { highlight } = useHighlightRow();

export default {
  data() {
    return {
      viewState: useEmployeeViewState(),
      currentFilterParams: {}, // Store current filter parameters for reloading
    };
  },
  components: {
    AddResponsibility,
    ExResponsibilityModal,
    EmployeeModal,
    ConfirmationDialog,
    RenameResponsibilityDialog,
    DeleteResponsibility,
    ActivateResponsibility,
    RetireResponsibility,
    DeActivateResponsibility,
    ReActivateResponsibility,
    DetachResponsibilityDialog,
  },
  computed: {
    renameResponsibilityModel() {
      return toRenameResponsibilityModel(this.currentResponsibility);
    },
  },
  methods: {
    async createDefaultBadge(data) {
      try {
        const payload = {
          level: 1,
          created_by: this.accountId,
          updated_by: this.accountId,
          issued_to: 7,
          issued_for: 7,
          issued_by: this.accountId,
          removed_by: this.accountId,
          given_expiration_days_issuance: data.whenGivenSelected,
          given_expiration_days: data.whenGivenExpiresInDays,
          awarded_expiration_days_issuance: data.whenAwardedSelected,
          awarded_expiration_days: data.whenAwardedExpiresInDays,
          awarded_expiration_obsolete: data.whenAwardedExpiresFromObsoleteInDays,
        };
        await updateResponsibilityDefaults(
          this.accountId,
          this.currentResponsibilityData.id,
          payload
        );
        this.$notifications.success("Default badge created successfully.");
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toast.error(error.response?.data.non_field_errors[0]);
        } else {
          this.$toast.error("Something went wrong, please try again.");
        }
      }
    },
    async loadResponsibilities() {
      try {
        const { data } = await getListofResponsibility(this.accountId, 1, 500);
        if (data && data.results) {
          this.dataSourceResponsibilities = data.results.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.parentId = -1;
            newEl.status = el.status ? el.status : "unknown"; // Safeguard status
            el.code = el.code ? el.code + "" : "N/A"; // Fallback value for code
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            return newEl;
          });
        }
      } catch (error) {
        console.error("Failed to fetch responsibilities: ", error);
      }
    },
    async createResponsibility({ name: responsibilityName, context: responsibilityContext = "" } = {}) {
      try {
        this.$loader.setAppLoading(true);
        const payload = {
          name: responsibilityName,
          account: this.accountId,
        };
        let responseData;
        if(this.$route?.params?.type === "responsibilities") {
          this.createNewResponsibility = true;
          const { data } = await createResponsibility(this.accountId, payload);
          responseData = data;
        }
        else {
          const { data } = await createResponsibility(this.accountId, payload);
          responseData = data;
        }

        const newResponsibility = responseData;
        if (responsibilityContext && newResponsibility?.id) {
          await updateResponsibilityContext(this.accountId, newResponsibility.id, {
            context: responsibilityContext,
          });
        }
        if(this.$route?.params?.type === "responsibilities") {
          if(this.createNewResponsibility) {
            this.searchItems = newResponsibility;
            this.defaultSearch = newResponsibility.code_str;
          }
          await this.loadDataSourceForReadinessCatalogs({
            limit: 10,
            offset: 0,
            search: newResponsibility.code_str,
            filters: this.appliedFiltersFromAPI || [],
          });
          
          this.$loader.setAppLoading(false);
          this.closeDialog();
          highlight({ id: newResponsibility.id, type: "Responsibilities" });
          return;
        }
        else {
          await this.loadNewDataSource();
        }
        const newResponsibilityIndex = this.sanitizeDataSource.findIndex(
          (el) => el.id === newResponsibility.id
        );
        const page = Math.ceil((newResponsibilityIndex + 1) / 10);
        this.paginationModel.page = page;
        this.dataSource = this.dataSourceResponsibilities;
        this.closeDialog();
        this.$loader.setAppLoading(false);
        highlight({ id: newResponsibility.id, type: "Responsibilities" });
        } catch (e) {
          console.error("error: ", e);
          this.responsibilityErrorMessage = getResponsibilityCreateErrorMessage(e);
        } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async onResponsibilityRenamed(updatedResponsibility, flagForPositionModal = false) {
      const type = this.currentResponsibility?.type;
      try {
        this.$loader.setAppLoading(true);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
        } else if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          if(this.createNewResponsibility) {
            this.searchItems = updatedResponsibility;
            this.defaultSearch = updatedResponsibility?.code_str;
          }
          await this.reloadCurrentPageData();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        } else {
          await this.loadDataSource();
          if (type === "roles") {
            this.dataSource = this.dataSourceRoles;
          } else {
            this.dataSource = this.dataSourceResponsibilities;
          }
        }
      } catch (e) {
        console.error("error: ", e);
      } finally {
        this.closeDialog();
        this.currentResponsibility = null;
        this.$loader.setAppLoading(false);
      }
    },
    async activateResponsibility(flagForPositionModal = false) {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentResponsibility?.realId;
        if (!id) {
          throw new Error("Data missing error");
        }
        const payload = {
          account_id: this.accountId,
          type: "responsibility",
          obj_id: id,
        };
        await updateActivateResponsibility(this.accountId, id, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.closeDialog();
        } else if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.closeDialog();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          if (typeof this.getRoleById === 'function' && this.currentRole?.id) {
            await this.getRoleById(this.currentRole.id);
          }
          this.closeDialog();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.closeDialog();
        } else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceResponsibilities;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.closeDialog();
        }
      } catch (e) {
        console.error("error: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async retireResponsibility(flagForPositionModal = false) {
      this.$loader.setAppLoading(true);
      try {
        const type = this.currentResponsibility?.type;
        const id = this.currentResponsibility?.realId;
        const name = this.currentResponsibility?.data?.name;
        if (!id || !name) {
          throw new Error("Data missing error");
        }
        const payload = {
          status: "retired",
          name: name,
          account: this.accountId,
        };
        await updateRetireResponsibility(this.accountId, id, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.closeDialog();
        } else if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.closeDialog();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          if (typeof this.getRoleById === 'function' && this.currentRole?.id) {
            await this.getRoleById(this.currentRole.id);
          }
          this.closeDialog();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.closeDialog();
        } else {
          await this.loadDataSource();
          this.dataSource =
            type === "roles"
              ? this.dataSourceRoles
              : this.dataSourceResponsibilities;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.closeDialog();
        }
      } catch (e) {
        console.log("error: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async deleteResponsibility(flagForPositionModal = false) {
      try {
        this.$loader.setAppLoading(true);
        const type = this.currentResponsibility?.type;
        const idRole = this.currentResponsibility.realId;
        await deleteResponsibility(this.accountId, idRole);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.deleteResponsibilityDialog = false;
        } else if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.deleteResponsibilityDialog = false;
          this.currentResponsibility = null;
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.deleteResponsibilityDialog = false;
          this.currentResponsibility = null;
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.deleteResponsibilityDialog = false;
          this.currentResponsibility = null;
        } else {
          this.actions.deleteResponsibilityDialog = false;
          this.currentResponsibility = null;
          await this.loadDataSource();
          this.dataSource =
            type === "roles"
              ? this.dataSourceRoles
              : this.dataSourceResponsibilities;

          const totalItemsAfterDeletion = this.paginationModel.total - 1;
          const totalPages = Math.ceil(
            totalItemsAfterDeletion / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.paginationModel.total = totalItemsAfterDeletion;
        }
      } catch (e) {
        console.error("e: ", e);
        this.$notifications.error(getDeleteErrorMessage(e, { entity: "responsibility" }));
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async tabChange(tabName) {
      this.$loader.show();
      if(tabName == "badge-holder" || !tabName) {
        await this.getResponsiblityBadges(this.currentResponsibilityData, this.paramType);
      }
      else if(tabName == "checklist") {
        await this.getResponsiblityChecklist(this.currentResponsibilityData);
      }
      else if(tabName === "assigments") {
        await this.getRespAssignments();
      }
      this.$loader.hide();
    },
    async loadResBadgeHolders(accountId, resId, type) {
      let data;
      try {
        if (type === "role") {
          const response = await getRoleId(accountId, resId);
          data = response.data;
        } else {
          const response = await getResponsibilityIdV2(accountId, resId, type);
          this.currentResponsibilityData = response.data;
        }
        if (data) {
          const newEl = {};
          newEl.id = data.id;
          newEl.realId = data.id;
          newEl.parentId = -1;
          newEl.archived = data.archived;
          newEl.avg_readiness = data.avg_readiness;
          newEl.status = data.status ? data.status : "unknown"; // Safeguard status
          data.code = this.getOrgCodeName(data);
          newEl.data = {
            type: "responsibility",
            ...data,
          };
          newEl.type = "responsibility";
          newEl.types = "";
          let typeCountRes = [];
          if (data.attachments && data.attachments.length > 0) {
            typeCountRes = data.attachments.reduce((acc, att) => {
              acc[att.type] = (acc[att.type] || 0) + 1;
              return acc;
            }, {});
          }
          data.attachments = Object.entries(typeCountRes).map(
            ([type, quantity]) => ({ type, quantity })
          );
          let totalCount = 0;
          if (data?.attachments_count) {
            totalCount = Object.values(data.attachments_count).reduce(
              (sum, count) => sum + count,
              0
            );
          }
          newEl.attachedTo = {
            data: data.attachments,
          };
          newEl.assignment = totalCount;
          this.currentOrgResponsibility = newEl;
          this.currentResponse = newEl;
          this.modalHeaderState = {
            status: data.status,
            icon: type === "role" ? "org_icon_role" : "org_icon_responsibility",
            label: data.name,
            code: this.getOrgCodeName(data),
            name: "",
            archived: data.archived,
          };
          // await this.getResponsiblityChecklist(data);
          // await this.getResponsiblityBadges(data, type);
          // await this.getResponsiblityChatter();
          // await this.getRespAssignments();
        }
        if (this.currentResponsibilityData && type === "responsibility") {
          const newEl = {};
          newEl.id = this.currentResponsibilityData.id;
          newEl.realId = this.currentResponsibilityData.id;
          newEl.archived = this.currentResponsibilityData.archived;
          newEl.avg_readiness = this.currentResponsibilityData.avg_readiness;
          newEl.status = this.currentResponsibilityData.status ? this.currentResponsibilityData.status : "unknown"; // Safeguard status
          this.currentResponsibilityData.code = this.getOrgCodeName(this.currentResponsibilityData);
          newEl.data = {
            type: "responsibility",
            ...this.currentResponsibilityData,
          };
          newEl.type = "responsibility";
          newEl.types = "";
          this.currentOrgResponsibility = newEl;
          this.currentResponse = newEl;
          this.modalHeaderState = {
            status: this.currentResponsibilityData.status,
            icon: type === "role" ? "org_icon_role" : "org_icon_responsibility",
            label: this.currentResponsibilityData.name,
            code: this.getOrgCodeName(this.currentResponsibilityData),
            name: "",
            archived: this.currentResponsibilityData.archived,
          };

          this.menuItems[0].count = (this.currentResponsibilityData.active_apprentice_checkpoints || 0) + 
            (this.currentResponsibilityData.active_coach_checkpoints || 0) + 
            (this.currentResponsibilityData.active_master_checkpoints || 0) + 
            (this.currentResponsibilityData.active_professional_checkpoints || 0);
          this.totalRespAssignments = this.currentResponsibilityData.assignments_count;
          
          // Always load checklist data to ensure pagination is set up correctly
          await this.getResponsiblityChecklist(this.currentResponsibilityData);
          
          const routeQuery = this.$route.query;
          if(routeQuery.tab === "assigments") {
            await this.getRespAssignments();
          }
          await this.getResponsiblityBadges(this.currentResponsibilityData, type);
        }
      } catch (e) {
        console.error("Error fetching responsibility data: ", e);
      }
    },
    async uploadVideo(id) {
      const data = {
        id: id,
      };
      await this.getResponsiblityChecklist(data);

      // Add setTimeout to periodically check video processing status
      let retryCount = 0;
      const maxRetries = 20; // Maximum 20 retries (1 minute total)

      const checkVideoProcessing = async () => {
        retryCount++;

        await this.getResponsiblityChecklist(data);

        // Get the current checkpoint that was uploaded
        const checkpointId = localStorage.getItem("selectedChecklist");
        const currentCheckpoint = this.checklistTask?.find(
          (task) => task.id === parseInt(checkpointId)
        );

        if (currentCheckpoint && currentCheckpoint.microlearning) {
          // Check if the microlearning content contains processing message
          const isProcessing =
            currentCheckpoint.microlearning.includes("being processed") ||
            currentCheckpoint.microlearning.includes(
              "will be available in a moment"
            ) ||
            currentCheckpoint.microlearning.includes("processing");

          if (!isProcessing) {
            // Video processing is complete, stop checking
            // Force a complete data refresh
            await this.getResponsiblityChecklist(data);

            // Force Vue to re-render by updating the array reference
            if (this.checklistTask) {
              this.checklistTask = [...this.checklistTask];
            }

            return;
          } else {
          }
        } else {
        }

        // If still processing and haven't reached max retries, check again
        if (retryCount < maxRetries) {
          setTimeout(checkVideoProcessing, 3000); // Check every 3 seconds
        } else {
        }
      };

      // Start checking after 2 seconds
      setTimeout(checkVideoProcessing, 2000);
    },

    async deleteVideo(id) {
      const data = {
        id: id,
      };
      await this.getResponsiblityChecklist(data);
    },

    getOrgCodeName(data) {
      if (data?.code_str) {
        return data.code_str.split(" ")[0];
      } else {
        return "#" + data.code;
      }
    },
    async getResponsiblityBadges(res, type) {

      const { data } = await getListofResponsibilityBadge(
        this.accountId,
        res.id,
        type
      );
      if (data && data.results) {
        this.dataResponsibilitiesBadge = data.results;
      }
      
      this.badgeFrameItems = this.dataResponsibilitiesBadge
        .filter((badge) => badge.issued_to) // Filter out badges without issued_to data
        .map((badge) => {
            let statusName = "";
            if (badge.status === "good_standing") {
              statusName = "Good Standing";
            } else if (badge.status === "forced" || badge.status == "given") {
              statusName = "Given";
            } else {
              statusName = "Obsolete";
            }
            return {
              id: badge.id,
              proficiencylevel: badge.level,
              avatar: badge.issued_to?.avatar || '',
              firstName: badge.issued_to?.first_name || '',
              lastName: badge.issued_to?.last_name || '',
              dot: statusName,
              empId: badge.issued_to?.id || null,
              is_current: badge.is_current,
              expires_when_obsolete: badge.expires_when_obsolete,
              removed_by: badge.removed_by,
              issued_method: badge.issued_method,
            };
        })
        .filter((item) => item !== undefined);
      this.menuItems[1].count = this.badgeFrameItems.filter(
        (el) => el?.removed_by === null
      ).length;
    },
    async addForceBadgeData(res) {
      // this.isAssigningBadge = true;
      this.$loader.setAppLoading(true);
      const resId = this.currentResponse?.id;
      try {
        const payload = {
          employee: res.employee.id,
          responsibility: resId,
          level: res.radioVal,
          forced: true,
        };
        this.$loader.show();
        await createProficiencyBadge(this.accountId, payload);
        await this.getResponsiblityBadges(this.currentResponsibilityData, this.paramType);
        this.showBadgeDialog = false;
        await this.fetchResponsibilityDetails();
        await this.updateEmployeeList();
        this.$loader.setAppLoading(false);
        this.$loader.hide();
        // this.isAssigningBadge = false;
      } catch (e) {
        console.error("Error adding badge: ", e);
        if (e.response && e.response.data && e.response.data.non_field_errors) {
          this.showBadgeDialog = false;
        }
        this.$loader.setAppLoading(false);
        this.$loader.hide();
        // this.isAssigningBadge = false;
      }
    },
    async confirmRemoveBadge() {
      try {
        this.$loader.setAppLoading(true);
        const payload = {
          badge: this.badgeData.id,
          method: "string",
          reason: "string",
        };
        await deleteResponsibilityBadge(
          this.accountId,
          this.badgeData.id,
          payload
        );
        await this.getResponsiblityBadges(this.currentResponse, this.paramType);
        await this.getRespAssignments();
        await this.fetchResponsibilityDetails();
        await this.updateEmployeeList(this.currentResponse?.id);
        this.$loader.setAppLoading(false);
        this.showConfirmDialog = false;
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("Error removing badge: ", e);
      }
    },
    async deActivateResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const type = this.currentResponsibility?.type;
        const id = this.currentResponsibility?.realId;
        const name = this.currentResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "inactive",
          name: this.currentResponsibility?.data?.name,
          account: this.accountId,
        };
        await responsibilityStateUpdate(this.accountId, id, payload);
        if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.closeDialog();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.closeDialog();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.closeDialog();
        } else {
          await this.loadDataSource();
          if (type === "roles") {
            this.dataSource = this.dataSourceRoles;
          } else {
            this.dataSource = this.dataSourceResponsibilities;
          }
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.closeDialog();
        }
      } catch (e) {
        console.error("error: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async reActivateResponsibility(flagForPositionModal = false) {
      this.$loader.setAppLoading(true);
      try {
        const type = this.currentResponsibility?.type;
        const id = this.currentResponsibility?.realId;
        const name = this.currentResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "active",
          name: this.currentResponsibility?.data?.name,
          account: this.accountId,
        };
        await updateReActivateResponsibility(this.accountId, id, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.closeDialog();
        } else if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.closeDialog();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          if (typeof this.getRoleById === 'function' && this.currentRole?.id) {
            await this.getRoleById(this.currentRole.id);
          }
          this.closeDialog();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.closeDialog();
        } else {
          await this.loadDataSource();
          if (type === "roles") {
            this.dataSource = this.dataSourceRoles;
          } else {
            this.dataSource = this.dataSourceResponsibilities;
          }
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.closeDialog();
        }
      } catch (e) {
        console.error("error: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async getResponsiblityChatter(isLoadMore = false) {
      // If this is initial load (not load more), reset the data and start from page 1
      if (!isLoadMore) {
        this.resChatter = [];
      }
      
      const page = Math.floor(this.resChatter.length / 10) + 1;
      const { data } = await getChatterList(
        this.accountId,
        this.currentResponse.id,
        "responsibility",
        page
      );
      if (data && data.count) {
        this.totalChatterData = data.count;
      }
      if (data && data.results) {
        let chatterItems = data.results.map((el) => {
          const date = new Date(el.recorded_on);
          const milliseconds = date.getTime();
          const millisecondsString = milliseconds.toString();
          let nameParts = el.recorded_by_name.split(" ");
          const newEl = {};
          newEl.id = el.id;
          if (nameParts.length === 2) {
            newEl.avatar = {
              picture: "",
              firstName: nameParts[0],
              lastName: nameParts[1],
            };
          } else {
            newEl.avatar = {
              picture: "",
              firstName: el.recorded_by_name,
              lastName: "",
            };
          }
          newEl.IsExIQtiveBot = false;
          newEl.message = el.note;
          newEl.created_on = millisecondsString;
          newEl.IsHistory = el.is_history;
          return newEl;
        });
        this.resChatter.push(...chatterItems);
      }
    },
    async getResponsiblityChecklist(res, paginationParams = null) {
      const params = paginationParams || {
        ordering: "proficiency_level"
      };
      
      // Store current filter parameters for future reloads
      this.currentFilterParams = { ...params };
      
      const data1 = await getResponsibilityChecklistV2(this.accountId, res.id, params);
      if (data1 && data1.data) {
        this.checklistTask = data1.data.map((el) => {
          let levelName = "";
          if (el.proficiency_level === 1) {
            levelName = "Apprentice";
          } else if (el.proficiency_level === 2) {
            levelName = "Professional";
          } else if (el.proficiency_level === 3) {
            levelName = "Coach";
          } else {
            levelName = "Master";
          }
          const newEl = {};
          newEl.id = el.id;
          newEl.level = levelName;
          newEl.criteria = el.criteria;
          newEl.instructions = el.instructions;
          newEl.status = el.status;
          newEl.prefix = el.prefix;
          newEl.has_microlearning = el.microlearning !== null ? true : false; // add dummy data for has_microlearning
          // newEl.has_watched_video = el.status === "active" ? true : false;  // add dummy data for
          newEl.microlearning = el.microlearning;
          newEl.microlearning_id = el.microlearning_video_id;
          return newEl;
        });
        this.menuItems[0].count = (this.currentResponsibilityData.active_apprentice_checkpoints || 0) + 
          (this.currentResponsibilityData.active_coach_checkpoints || 0) + 
          (this.currentResponsibilityData.active_master_checkpoints || 0) + 
          (this.currentResponsibilityData.active_professional_checkpoints || 0);
      }
      
      // Return the API response so the calling component can access the total count
      return data1;
    },
    async reloadChecklistWithPaginationCheck() {
      // Use stored filter parameters to reload checklist
      const params = {
        ...this.currentFilterParams, // Include all current filters (status, search, proficiency_level, etc.)
        ordering: "proficiency_level"
      };
      
      try {
        await this.getResponsiblityChecklist(this.currentResponse, params);
      } catch (error) {
        console.error('Error reloading checklist:', error);
        // Fallback to default filters
        const fallbackParams = {
          ...this.currentFilterParams,
          ordering: "proficiency_level"
        };
        await this.getResponsiblityChecklist(this.currentResponse, fallbackParams);
      }
    },
    async checkFormData(data) {
      try {
        let levelName = "";
        if (data.level === "Apprentice") {
          levelName = 1;
        } else if (data.level === "Professional") {
          levelName = 2;
        } else if (data.level === "Coach") {
          levelName = 3;
        } else {
          levelName = 4;
        }
        const payload = {
          proficiency_level: levelName,
          criteria: data.criteria,
          prefix: formatCriteriaPrefix(data.prefix),
          instructions: data.instructions,
          account: this.accountId,
          responsibility: this.currentResponse?.id,
        };
        this.$loader.setAppLoading(true);
        const response = await createResponsibilityCheckpointV2(
          this.accountId,
          this.currentResponse?.id,
          payload
        );

        // Get the newly created checkpoint data from the response
        const newCheckpoint = response.data;

        this.$loader.setAppLoading(false);
        
        // Search for the newly added checkpoint's criteria
        const searchParams = {
          ordering: "proficiency_level",
          search: data.criteria // Add the new checkpoint's criteria to search
        };
        
        // Store the search parameters for future reloads
        this.currentFilterParams = { ...searchParams };
        
        // Emit event to update search UI in ChecklistCriteriaTable
        this.$emit('updateSearchAfterAdd', data.criteria);
        
        await this.getResponsiblityChecklist(this.currentResponse, searchParams);
        
        // Refresh responsibility details to update level counts
        await this.fetchResponsibilityDetails();
        
        // Highlight the newly created checkpoint
        highlight({ id: newCheckpoint.id, type: "Checklists" });
      } catch (e) {
        console.error("Error adding checkpoint: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async deleteCheckpoint(id) {
      this.$loader.setAppLoading(true);
      const account_id = JSON.parse(localStorage.getItem("currentAccountID"));
      const res_id = this.getResponsibilityId(this.$route.path);
      try {
        if (id) {
          await deleteResponsibilityCheckpoint(account_id, res_id, id);
          
          // Reload data with current pagination to check if page is still valid
          await this.reloadChecklistWithPaginationCheck();
          
          // Refresh responsibility details to update level counts
          await this.fetchResponsibilityDetails();
        }
      } catch (e) {
        console.log("Error deleting checkpoint: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
      this.showDeleteDialog = false;
    },
    getResponsibilityId(route) {
      const currnetRoute = route;
      const parts = currnetRoute.split("/");
      return parts[parts.length - 1];
    },
    requestSelfAppointPrompt() {
      useSelfAppointPromptStore().requestPrompt({
        responsibilityId: this.currentResponse?.id,
        responsibilityName: this.currentResponse?.name,
      });
    },
    async activateCheckpoint() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentCheckPoint?.id;
        const res_id = this.currentResponse?.id;
        if (!id) {
          throw new Error("Data missing error");
        }
        await changeCheckpointV2(this.accountId, res_id, id, { status: "active" });
        
        // Reload data with current pagination to check if page is still valid
        await this.reloadChecklistWithPaginationCheck();
        
        // Refresh responsibility details to update level counts
        await this.fetchResponsibilityDetails();
        
        this.showActivateCheckpointDialog = false;
        this.requestSelfAppointPrompt();
      } catch (e) {
        console.error("Error activating checkpoint: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async retireCheckpoint() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentCheckPoint?.id;
        const res_id = this.currentResponse?.id;

        if (!id) {
          throw new Error("Data missing error");
        }
        await changeCheckpointV2(this.accountId, res_id, id, { status: "retired" });
        
        // Reload data with current pagination to check if page is still valid
        await this.reloadChecklistWithPaginationCheck();
        
        // Refresh responsibility details to update level counts
        await this.fetchResponsibilityDetails();
        
        this.showRetireCheckpointDialog = false;
      } catch (e) {
        console.error("Error retiring checkpoint: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async reActivateCheckpoint() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentCheckPoint?.id;
        const res_id = this.currentResponse?.id;
        if (!id) {
          throw new Error("Data missing error");
        }
        await checkpointStateUpdate(this.accountId, res_id, id, "reactivate");
        
        // Reload data with current pagination to check if page is still valid
        await this.reloadChecklistWithPaginationCheck();
        
        // Refresh responsibility details to update level counts
        await this.fetchResponsibilityDetails();
        
        this.showReActivateCheckpointDialog = false;
        this.requestSelfAppointPrompt();
      } catch (e) {
        console.error("Error reactivating checkpoint: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async changeCheckpoint(data) {
      try {
        const id = this.currentCheckPoint?.id;
        const res_id = this.currentResponse?.id;
        if (!id) {
          throw new Error("Data missing error");
        }
        await changeCheckpoint(this.accountId, res_id, id, data);
        
        // Reload data with current pagination to check if page is still valid
        await this.reloadChecklistWithPaginationCheck();
        
        // Refresh responsibility details to update level counts (in case level changed)
        await this.fetchResponsibilityDetails();
      } catch (e) {
        console.error("Error changing checkpoint: ", e);
      }
    },
    async updateCheckpointOrder(data) {
      try {
        const res_id = this.currentResponse?.id;
        if (!res_id) {
          throw new Error("Data missing error");
        }
        const payload = {
          checkpoint_order: data,
        };
        await onUpdateCheckpointOrder(this.accountId, res_id, payload);
        this.getResponsiblityChecklist(this.currentResponse);
      } catch (e) {
        console.error("Error updating checkpoints order: ", e);
      }
    },
    async openEvalResponse(data) {
      this.showBadgeDialog = false;
      this.evalModalHeaderState = {
        responsibilityCode: this.currentResponse?.data?.code || '',
        responsibilityName: this.currentResponse?.data?.name || '',
        roleCode: "#245",
        roleName: "Implement CAPEX initiatives",
        positionCode: "#4567",
        positionName: "General Manager",
      };
      const employeeCurrentBadge =
        data?.employee?.currentBadge &&
        data?.employee?.currentBadge?.issued_for?.code ===
          this.currentResponse?.data?.code_str
          ? {
              id: data?.employee?.currentBadge?.id,
              level: data?.employee?.currentBadge?.level,
              status: data?.employee?.currentBadge?.status,
            }
          : null;
      this.evalModalEmpState = {
        id: data.employee.id,
        firstName: data.employee.firstName,
        lastName: data.employee.lastName,
        position: data.employee.title,
        photoUrl: data.employee.avatar,
        availability: 1,
        isAllocated: false,
        access: data.employee.access || {}, // Ensure access is included with a default empty object if not present
        badgeList: data.employee.badgeList,
        currentEmployeeBadge: employeeCurrentBadge,
        user: data.employee.user || null, // Include the user object
      };
      await this.loadListActiveCheckpointsEvalV2(data);
      this.openEvalResponsibility = true;
    },
    async loadListActiveCheckpointsEval(data) {
      const data3 = await getListActiveCheckpointsEval(
        this.accountId,
        this.currentResponse.id,
        data.employee.id
      );
      if (data3 && data3.data) {
        this.checkpointsData = data3.data.map((el) => {
          const newEl = {};
          newEl.id = el.id;
          newEl.status = el.id;
          newEl.level = el.proficiency_level;
          newEl.level_name = this.getProficiencyLevelNameFromNumber(el);
          newEl.criteria = el.criteria;
          newEl.instructions = el.instructions;
          newEl.status = el.status;
          newEl.evaluation_status = el.evaluation_status;
          newEl.change_evaluation_status =
            this.updateChangeEvaluationStatus(el);
          newEl.failed_by = "Test user";
          newEl.failed_on = "Test user";
          newEl.failed_reason = el.evaluation_reason;
          newEl.reset_by = null;
          newEl.reset_on = "";
          newEl.reset_reason = "";
          newEl.updated_on = el.updated_on;
          newEl.updated_by = el.updated_by;
          newEl.avatar = el.avatar;
          return newEl;
        });
      }
      return this.checkpointsData;
    },
    async loadListActiveCheckpointsEvalV2(data) {
      const limit = this.currentOrgResponsibility?.data?.active_checkpoints_count || 0;
      const offset = 0;
      
      const data4 = await getListActiveCheckpointsEvalV2(
        this.accountId,
        this.currentResponse.id,
        data.employee.id,
        limit,
        offset
      );
      if (data4 && data4.data) {
        this.checkpointsData = data4.data?.results.map((el) => {
          const newEl = {};
          newEl.id = el.checkpoint;
          newEl.checkpoint_id = el.checkpoint;
          newEl.level = el.proficiency_level;
          newEl.level_name = this.getProficiencyLevelNameFromNumber(el);
          newEl.criteria = el.checkpoint_criteria;
          newEl.instructions = el.checkpoint_instructions;
          newEl.status = el.status;
          newEl.evaluation_status = el.status;
          newEl.change_evaluation_status =
            this.updateChangeEvaluationStatus(el);
          newEl.failed_by = el.evaluated_by?.name || null;
          newEl.failed_on = el.evaluated_on;
          newEl.failed_reason = el.reason;
          newEl.reset_by = el.reset_by;
          newEl.reset_on = el.reset_on || "";
          newEl.reset_reason = "";
          newEl.updated_on = el.evaluated_on;
          newEl.updated_by = {
            ...el.evaluated_by,
            picture: el.evaluator_avatar,
          };
          newEl.avatar = el.evaluator_avatar;
          return newEl;
        });
      }
      return this.checkpointsData;
    },
    getProficiencyLevelNameFromNumber(el) {
      let levelName = "";
      if (el.proficiency_level === 1) {
        levelName = "Apprentice";
      } else if (el.proficiency_level === 2) {
        levelName = "Professional";
      } else if (el.proficiency_level === 3) {
        levelName = "Coach";
      } else {
        levelName = "Master";
      }
      return levelName;
    },
    updateChangeEvaluationStatus(data) {
      if (data.evaluation_status == "not_applicable" || data.status == "not_applicable") {
        return "Not Applicable";
      } else if (data.evaluation_status == "passed" || data.status == "passed") {
        return "Passed";
      } else if (data.evaluation_status == "failed" || data.status == "failed") {
        return "Failed";
      } else if (data.evaluation_status == "reset" || data.status == "reset") {
        return "Reset Pending Evaluation";
      } else {
        return "Pending Evaluation";
      }
    },
    async getCheckpointChatterList(checkpoint, page) {
      if (page === 1) {
        this.chatterList = [];
      }
      const { data } = await getChatterList(
        this.accountId,
        checkpoint.id,
        "checkpoint",
        page
      );
      if (data && data.count) {
        this.totalCheckpointChatter = data.count;
      }
      if (data && data.results) {
        let chatterItems = data.results.map((el) => {
          const date = new Date(el.recorded_on);
          const milliseconds = date.getTime();
          const millisecondsString = milliseconds.toString();
          let nameParts = el.recorded_by_name.split(" ");
          const newEl = {};
          newEl.id = el.id;
          if (nameParts.length === 2) {
            newEl.avatar = {
              picture: "",
              firstName: nameParts[0],
              lastName: nameParts[1],
            };
          } else {
            newEl.avatar = {
              picture: "",
              firstName: el.recorded_by_name,
              lastName: "",
            };
          }
          newEl.IsExIQtiveBot = false;
          newEl.message = this.truncateHtml(el.note);
          newEl.created_on = millisecondsString;
          newEl.IsHistory = el.is_history;
          return newEl;
        });
        this.chatterList.push(...chatterItems);
      }
    },
    truncateHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      let text = div.textContent || div.innerText || "";
      return text;
    },
    async detachResponsibility() {
      try {
        const payload = {
          parent_id: this.currentResponsibility.parentId,
        };
        await detachOrgObject(this.accountId, {
          childType: this.currentResponsibility.data.type,
          childId: this.currentResponsibility.data.id,
          parentData: payload,
        });
        if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.closeDialog();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.closeDialog();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.closeDialog();
        } else {
          this.closeDialog();
          await this.loadDataSource();
        }
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async fetchResponsibilityDetails() {
      const type = "responsibility";
      const response = await getResponsibilityIdV2(
        this.accountId,
        this.$route.params.objId,
        type
      );
      const data = response.data;
      this.currentResponsibilityData = data;
      if (this.currentResponsibilityData) {
        const newEl = {};
        newEl.id = this.currentResponsibilityData.id;
        newEl.realId = this.currentResponsibilityData.id;
        newEl.archived = this.currentResponsibilityData.archived;
        newEl.avg_readiness = this.currentResponsibilityData.avg_readiness;
        newEl.status = this.currentResponsibilityData.status ? this.currentResponsibilityData.status : "unknown"; // Safeguard status
        this.currentResponsibilityData.code = this.getOrgCodeName(this.currentResponsibilityData);
        newEl.data = {
          type: "responsibility",
          ...this.currentResponsibilityData,
        };
        newEl.type = "responsibility";
        newEl.types = "";
        this.currentOrgResponsibility = newEl;
        this.currentResponse = newEl;
        this.modalHeaderState = {
          status: this.currentResponsibilityData.status,
          icon: type === "role" ? "org_icon_role" : "org_icon_responsibility",
          label: this.currentResponsibilityData.name,
          code: this.getOrgCodeName(this.currentResponsibilityData),
          name: "",
          archived: this.currentResponsibilityData.archived,
        };
        this.menuItems[0].count = (this.currentResponsibilityData.active_apprentice_checkpoints || 0) + 
          (this.currentResponsibilityData.active_coach_checkpoints || 0) + 
          (this.currentResponsibilityData.active_master_checkpoints || 0) + 
          (this.currentResponsibilityData.active_professional_checkpoints || 0);
        this.totalRespAssignments = this.currentResponsibilityData.assignments_count;
      }
    },
    async updateImportanceValue() {
      this.$loader.show();
      await updateImportanceValue(this.accountId, this.updateImportanceData);
      await this.getRespAssignments();
      await this.fetchResponsibilityDetails();
      this.$loader.hide();
    },
    async getRespAssignments() {
      const { data } = await getResponsibilityAssignments(
        this.accountId,
        this.currentResponse.id
      );
      if (data) {
        let respAssignments = data.map((el) => {
          const assignedDate = this.foromatedDate(el.assigned_on);
          const removedDate = this.foromatedDate(el.removed_on);
          let employeeName = el.employee_name.split(" ");
          const regex = /(#\d+)\s*-\s*(.*)/;
          const match = el.position_code?.match(regex);
          const code = match?.[1];
          const position = el.position_name;
          const roleMatch = el.role_code?.match(regex);
          const roleCode = roleMatch?.[1];
          const roleName = el.role_name;

          const newEl = {};
          newEl.id = el.id;
          newEl.avatar = el.employee_avatar;
          newEl.nameUrl = `/organization/employees/${el.employee_id}/pathtoreadiness`;
          newEl.first_name = employeeName[0];
          newEl.last_name = employeeName.slice(1).join(" ");
          newEl.availability = el.employee_availability;
          newEl.current_status = this.getAssignmentStatus(el.status);
          newEl.badge_id = el.badge_id;
          newEl.employee_id = el.employee_id;
          newEl.assignment_id = el.assignment_id;
          newEl.assigned_by = el.assigned_by;
          newEl.assigned_on = assignedDate;
          newEl.removed_by = el.removed_by;
          newEl.removed_on = removedDate;
          newEl.importance_level = el.importance;
          newEl.position_name = position;
          newEl.position_code = code;
          newEl.positionNameCode= el.position_code;
          newEl.roleNameCode= el.role_code;
          newEl.role_name = roleName;
          newEl.role_code = roleCode;
          return newEl;
        });
        this.assignmentsList.splice(
          0,
          this.assignmentsList.length,
          ...respAssignments
        );
      }
    },
    getAssignmentStatus(status) {
      if (status?.includes("Terminated")) {
        return "terminated";
      }
      if (status?.includes("Retired")) {
        return "retired";
      }
      if (status?.includes("Relieved")) {
        return "relieved";
      }
      if (status?.includes("Detached")) {
        return "detached";
      }
      return status;
    },
    foromatedDate(date) {
      const originalDate = new Date(date);
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[originalDate.getMonth()];
      const year = originalDate.getFullYear();
      const day = originalDate.getDate();

      return `${year}-${month}-${day}`;
    },
    async archiveResponsibility(type = "") {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentResponsibility?.realId;
        const objTpye = "responsibility";

        await updateArchiveResponsibility(this.accountId, objTpye, idRole);
        if (type === "attachRes") {
          this.showArchihvedResponsiblityDialog = false;
        } else {
          this.actions.showArchiveDialog = false;
        }
        this.currentResponsibility = null;
        if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        } else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceResponsibilities;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async unarchiveResponsibility(type = "") {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentResponsibility?.realId;
        const objTpye = "responsibility";

        await updateUnArchiveResponsibility(this.accountId, objTpye, idRole);
        if (type === "attachRes") {
          this.showArchihvedResponsiblityDialog = false;
        } else {
          this.actions.showArchiveDialog = false;
        }
        this.currentResponsibility = null;
        if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        } else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceResponsibilities;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async reOrderData(reOrderData) {
      try {
        const { data } = await reOrderSequenceData(this.accountId, reOrderData?.roleId, reOrderData?.reordered_ids);
        if (data) {
          this.$notifications.success("Order updated successfully.");
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toast.error(error.response?.data.non_field_errors[0]);
        } else {
          this.$toast.error("Something went wrong, please try again.");
        }
      }
    },
    async getListOfResponsibilities(role_id, page = 1, searchTerm = "", isLoadMore = false) {
      const limit = 10;
      const offset = (page - 1) * limit;
      const name = searchTerm || "";
      
      try {
        if(!isLoadMore) {
          this.items = [];
        }
        this.isLoadingMore = true;
        
        const attachableResponsibilities = await fetchAttachableResponsibilities(
          this.accountId,
          role_id,
          limit,
          offset,
          name
        );
        
        const newItems = attachableResponsibilities.data.results.map((item) => ({
          id: item.id,
          code: item.code_str.match(/\d+/)[0],
          name: item.name,
          status: item.status,
          attached: item?.attached_to_role
        }));
        
        if (isLoadMore && this.items) {
          this.items = [...this.items, ...newItems];
        } else {
          this.items = newItems;
        }
        
        this.currentPage = page;
        this.totalCount = attachableResponsibilities.data.count || 0;
        this.hasMoreData = (page * limit) < this.totalCount;
        
      } catch (error) {
        console.error("Search error:", error);
        this.$toast.error("Failed to load responsibilities");
      } finally {
        this.isLoadingMore = false;
      }
    },
    
    async loadMoreResponsibilities() {
      if (this.isLoadingMore || !this.hasMoreData) {
        return;
      }
      
      const nextPage = this.currentPage + 1;
      await this.getListOfResponsibilities(this.currentRoleId, nextPage, this.currentSearchTerm, true);
    },
    
    async searchResponsibilities(searchTerm) {
      this.currentSearchTerm = searchTerm;
      this.currentPage = 1;
      this.hasMoreData = true;
      await this.getListOfResponsibilities(this.currentRoleId, 1, searchTerm, false);
    },
    async getListOfRoles(res_id, page = 1, searchTerm = "", isLoadMore = false) {
      const limit = 10;
      const offset = (page - 1) * limit;
      const name = searchTerm || "";
      
      try {
        if(!isLoadMore) {
          this.attachableRoles = [];
        }
        // Set loading state for pagination
        this.isLoadingMore = true;
        
        const attachableeRoles = await fetchAttachableRoles(
          this.accountId,
          res_id,
          limit,
          offset,
          name
        );
        
        const newItems = attachableeRoles.data.results.map((item) => ({
          id: item.id,
          code: item.code_str.match(/\d+/)[0],
          name: item.name,
          status: item.status,
          attached: item?.attached_to_responsibility
        }));
        
        // If it's a load more request, append to existing items
        if (isLoadMore && this.attachableRoles) {
          this.attachableRoles = [...this.attachableRoles, ...newItems];
        } else {
          // If it's initial load or search, replace items
          this.attachableRoles = newItems;
        }
        
        // Update pagination state
        this.currentPage = page;
        this.totalCount = attachableeRoles.data.count || 0;
        // hasMoreData should be true if there are more records beyond current page
        this.hasMoreData = (page * limit) < this.totalCount;
        
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        // Clear loading state
        this.isLoadingMore = false;
      }
    },
    
    // Method to handle load more for pagination
    async loadMoreRoles() {
      if (this.isLoadingMore || !this.hasMoreData) {
        return;
      }
      
      const nextPage = this.currentPage + 1;
      await this.getListOfRoles(this.currentResponsibilityId, nextPage, this.currentSearchTerm, true);
    },
    
    // Method to handle search with pagination reset
    async searchRoles(searchTerm) {
      this.currentSearchTerm = searchTerm;
      this.currentPage = 1;
      this.hasMoreData = true;
      await this.getListOfRoles(this.currentResponsibilityId, 1, searchTerm, false);
    },
    async getListOfRolesForPosition(position_id, page = 1, searchTerm = "", isLoadMore = false) {
      const limit = 10;
      const offset = (page - 1) * limit;
      const name = searchTerm || "";
      
      try {
        if(!isLoadMore) {
          this.attachRolesForPosition = [];
        }
        // Set loading state for pagination
        this.isLoadingMore = true;
        
        const attachableeRoles = await fetchAttachableRolesForPosition(
          this.accountId,
          position_id,
          limit,
          offset,
          name
        );
        
        const newItems = attachableeRoles.data.results.map((item) => ({
          id: item.id,
          code: item.code_str.match(/\d+/)[0],
          name: item.name,
          status: item.status,
          attached: item?.attached_to_position
        }));
        
        // If it's a load more request, append to existing items
        if (isLoadMore && this.attachRolesForPosition) {
          this.attachRolesForPosition = [...this.attachRolesForPosition, ...newItems];
        } else {
          // If it's initial load or search, replace items
          this.attachRolesForPosition = newItems;
        }
        
        // Update pagination state
        this.currentPage = page;
        this.totalCount = attachableeRoles.data.count || 0;
        // hasMoreData should be true if there are more records beyond current page
        this.hasMoreData = (page * limit) < this.totalCount;
        
      } catch (error) {
        console.error("Search error:", error);
        this.$toast.error("Failed to load responsibilities");
      } finally {
        // Clear loading state
        this.isLoadingMore = false;
      }
    },
    
    // Method to handle load more for pagination
    async loadMoreRolesForPosition() {
      if (this.isLoadingMore || !this.hasMoreData) {
        return;
      }
      
      const nextPage = this.currentPage + 1;
      await this.getListOfRolesForPosition(this.currentPositionId, nextPage, this.currentSearchTerm, true);
    },
    
    // Method to handle search with pagination reset
    async searchRolesForPosition(searchTerm) {
      this.currentSearchTerm = searchTerm;
      this.currentPage = 1;
      this.hasMoreData = true;
      await this.getListOfRolesForPosition(this.currentPositionId, 1, searchTerm, false);
    },
    
    convertFiltersToAPIFormat(filters) {
      const apiFilters = {};
      let hasShowFilter = false;
      let hasDoNotShowFilter = false;
      
      filters.forEach(filter => {
        if (typeof filter === 'object' && filter.labelType) {
          switch (filter.labelType) {
            case 'Status':
              if (!apiFilters.status) {
                apiFilters.status = [];
              }
              if (filter.value && filter.value !== 'No Filter') {
                apiFilters.status.push(filter.value);
              }
              break;
            case 'Coverage':
              if (filter.value === 'No Masters') {
                apiFilters.no_masters = true;
              } else if (filter.value === 'No Coaches') {
                apiFilters.no_coaches = true;
              } else if (filter.value === 'No Professionals') {
                apiFilters.no_professionals = true;
              }
              break;
            case 'Archived':
              if (filter.value === 'Show') {
                hasShowFilter = true;
                apiFilters.archived = true;
              } else if (filter.value === 'Do not Show') {
                hasDoNotShowFilter = true;
                apiFilters.archived = false;
              }
              break;
            case 'Attachments':
              if (filter.value === 'No Positions' && this.$route?.params?.type === "responsibilities") {
                apiFilters.attachments = 'no';
              }
              else if (filter.value === 'No Positions' && this.$route?.params?.type === "roles") {
                apiFilters.positions = 'no';
              }
              else if (filter.value === 'No Responsibilities' && this.$route?.params?.type === "roles") {
                apiFilters.responsibilities = 'no';
              }
              else if (filter.value === 'No Roles') {
                apiFilters.roles = 'no';
              }
              break;
            case 'Timeline':
              if (filter.value === 'Recently Activated') {
                apiFilters.recently_activated = true;
              } else if (filter.value === 'Recently Retired') {
                apiFilters.recently_retired = true;
              } else if (filter.value === 'Recently Deactivated') {
                apiFilters.recently_deactivated = true;
              } else if (filter.value === 'Recently Created') {
                apiFilters.recently_created = true;
              }
              break;
          }
        } else if (typeof filter === 'object' && filter.value) {
          // Handle object filters without labelType but with value (status filters)
          if (!apiFilters.status) {
            apiFilters.status = [];
          }
          if (['draft', 'active', 'retired', 'inactive'].includes(filter.value)) {
            apiFilters.status.push(filter.value);
          }
        } else if (typeof filter === 'string') {
          // Handle string filters - need to determine the filter type based on the value
          if (['draft', 'active', 'retired', 'inactive'].includes(filter)) {
            // Status filters
            if (!apiFilters.status) {
              apiFilters.status = [];
            }
            apiFilters.status.push(filter);
          } else if (filter === 'No Positions') {
            // Attachments filter
            if (this.$route?.params?.type === "responsibilities") {
              apiFilters.attachments = 'no';
            }
            else if (this.$route?.params?.type === "roles") {
              apiFilters.positions = 'no';
            }
          } 
          else if (filter === 'No Responsibilities') {
            apiFilters.responsibilities = 'no';
          }
          else if (filter === 'No Roles') {
            apiFilters.roles = 'no';
          }
          else if (filter === 'No Masters') {
            // Coverage filter
            apiFilters.no_masters = true;
          } else if (filter === 'No Coaches') {
            // Coverage filter
            apiFilters.no_coaches = true;
          } else if (filter === 'No Professionals') {
            // Coverage filter
            apiFilters.no_professionals = true;
          } else if (filter === 'Show') {
            // Archived filter
            hasShowFilter = true;
            apiFilters.archived = true;
          } else if (filter === 'Do not Show') {
            // Archived filter
            hasDoNotShowFilter = true;
            apiFilters.archived = false;
          } else if (filter === 'Recently Activated') {
            // Timeline filter
            apiFilters.recently_activated = true;
          } else if (filter === 'Recently Retired') {
            // Timeline filter
            apiFilters.recently_retired = true;
          } else if (filter === 'Recently Deactivated') {
            // Timeline filter
            apiFilters.recently_deactivated = true;
          } else if (filter === 'Recently Created') {
            // Timeline filter
            apiFilters.recently_created = true;
          }
        }
      });
      
      // Only apply archived=false if no archived filter is explicitly set
      if (!hasShowFilter && !hasDoNotShowFilter) {
        apiFilters.archived = false;
      }
      return apiFilters;
    },
  },
};
